import { useState, useEffect, useCallback } from "react";

export const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

/**
 * Calculates previous month and year relative to current date.
 * E.g., if current date is Oct 2026, returns { month: "September", year: "2026" }.
 * If current date is Jan 2027, returns { month: "December", year: "2026" }.
 */
export const getPreviousMonthAndYear = () => {
  const d = new Date();
  d.setDate(1); // Set day to 1 to prevent month-end rollover issues (e.g. 31st to 28th/30th)
  d.setMonth(d.getMonth() - 1);
  return {
    month: MONTH_NAMES[d.getMonth()],
    year: String(d.getFullYear())
  };
};

/**
 * Custom hook to read and subscribe to global active session from Header (Firm, Branch, Month, Year).
 * Updates automatically across components whenever Header changes Firm, Branch, Month, or Year!
 */
export const useSession = () => {
  const getSession = useCallback(() => {
    let firm = null;
    let branch = null;
    let month = "";
    let year = "";
    try {
      firm = JSON.parse(localStorage.getItem("selectedFirm") || "null");
    } catch {
      firm = null;
    }
    try {
      branch = JSON.parse(localStorage.getItem("selectedBranch") || "null");
    } catch {
      branch = null;
    }
    const defaultPeriod = getPreviousMonthAndYear();
    month = localStorage.getItem("selectedPayrollMonth") || defaultPeriod.month;
    year = localStorage.getItem("selectedPayrollYear") || defaultPeriod.year;

    return {
      firm,
      firmId: firm?.Id || 0,
      firmName: firm?.Name || "",
      branch,
      branchId: branch?.Id || 0,
      branchName: branch?.Name || "",
      month,
      year,
    };
  }, []);

  const [session, setSession] = useState(getSession);

  useEffect(() => {
    const handleUpdate = () => {
      setSession(getSession());
    };

    window.addEventListener("storage", handleUpdate);
    window.addEventListener("sessionChange", handleUpdate);
    return () => {
      window.removeEventListener("storage", handleUpdate);
      window.removeEventListener("sessionChange", handleUpdate);
    };
  }, [getSession]);

  return session;
};

export default useSession;
